"use strict";

export default {
  moduleSitzungSekundaer: "4faa0c78-bf4d-493f-9aaf-03fe34bcf465",
  moduleSitzungNichtLaden: "6150b7d5-50d4-4e74-b048-7397765e810f"
};
